import axios from 'axios'
import { BLOCK_EMPLOYEE_URL } from './consts'

export const postUnblockEmployee = (id: number) => {
  return axios.post(`${BLOCK_EMPLOYEE_URL}${id}`, {
    enabled: true,
  })
}
